<template>
  <div class="box">

    <div class="text">

      <div class="switch-bottom-box" @click="onChangeBottomBar">
        <font-awesome-icon icon="caret-up" class="icon" v-if="getBottomBarState.question"/>
        <font-awesome-icon icon="caret-down" class="icon" v-if="!getBottomBarState.question"/>
      </div>

      <div class="play-box" v-if="getCurrentBotAudioType">
        <div @click="playButton" :class="{ play: true, playing: playing }" title="Play/Stop">
          <font-awesome-icon icon="volume-up" class="icon"/>
        </div>
      </div>

      <textarea class='autoExpand' ref="questionInput" @keydown.enter="prevent" @change="saveText" placeholder="Add question ..." maxlength="350" spellcheck="false" v-model="text"></textarea>
    </div>

    <div class="bottom-bar" v-if="getBottomBarState.question">
    <div class="option-bar">
      <div class="switch">
        <div class="bot" @click="botSwitchChange" :class="{ active: this.switch == 'bot' }" title="Automatic voice">
          <font-awesome-icon icon="robot"/>
        </div>
        <div class="micro" @click="microSwitchChange" :class="{ active: this.switch == 'micro' }" title="Record voice">
          <font-awesome-icon icon="microphone"/>
        </div>
      </div>

      <div class="background-trigger-box">
        <div :class="{'background-button': true, 'active': paletteBar == 'bg'}" @click="backgroundPaletteSwitch" title="Background">
          <font-awesome-icon icon="image" class="icon"/>
        </div>
      </div>

      <div class="person-trigger-box">
        <div :class="{'person-button': true, 'active': paletteBar == 'person'}" @click="personPaletteSwitch" title="Person">
          <font-awesome-icon icon="user-alt" class="icon"/>
        </div>
      </div>

      <div class="delete-box" v-if="botData.id != getFirstBotId" title="Delete">
        <div class="delete-button" @click="onDelete">
          <font-awesome-icon icon="trash" class="icon"/>
        </div>
      </div>
    </div>

    <div class="palette-bar" v-if="paletteBar">
      <div class="tts-menu" v-if="paletteBar == 'bot'">
        <select name="tts-voice" v-model="selectedVoice" @change="onVoiceChange" title="Language">
          <option v-for="(voice, index) in voices" :key="index" :value="{ name: voice.name, lang: voice.lang }">
            {{ voice.name }}
          </option>
        </select>
      </div>
      <div class="record-menu" v-if="paletteBar == 'micro'">
        <div :class="{ record: true, recording }" @click="recordButton" title="Record/Stop">
          <font-awesome-icon v-if="!recording" icon="circle"/>
          <font-awesome-icon v-if="recording" icon="stop"/>
        </div>
        <div class="timer" >
          {{ time }} / 00:60
        </div>
      </div>

      <div class="background-menu" v-if="paletteBar == 'bg'">
        <div class="background-shell">

          <div class="bg-box">
            <div :class="{'upload-btn-wrapper': true, selected: getCurrentBotBg.type == 'upload'}" :style="{'background-image': 'url(' + getUploadedBackground + ')'}">
              <input type="file" name="myfile" class="uploadedBackground" @input="uploadBackground" @click="inputBackgroundClick" title=""/>
              <div class="label">Upload</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image-default': true, selected: getCurrentBotBg.type == 'color' }" :style="{ backgroundColor: bg_color.hex }" @click="pickerSwitch()">
              <div class="label">color</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 1 }" @click="onBgChange({ type: 'stock', data: 1 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_1_s.jpg') + ')'}">
              <div class="label">City</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 2 }" @click="onBgChange({ type: 'stock', data: 2 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_2_s.jpg') + ')'}">
              <div class="label">Beach</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 3 }" @click="onBgChange({ type: 'stock', data: 3 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_3_s.jpg') + ')'}">
              <div class="label">Airport</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 4 }" @click="onBgChange({ type: 'stock', data: 4 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_4_s.jpg') + ')'}">
              <div class="label">City 2</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 5 }" @click="onBgChange({ type: 'stock', data: 5 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_5_s.jpg') + ')'}">
              <div class="label">Sport</div>
            </div>
          </div>

          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 6 }" @click="onBgChange({ type: 'stock', data: 6 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_6_s.jpg') + ')'}">
              <div class="label">Country</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 7 }" @click="onBgChange({ type: 'stock', data: 7 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_7_s.jpg') + ')'}">
              <div class="label">Factory</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 8 }" @click="onBgChange({ type: 'stock', data: 8 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_8_s.jpg') + ')'}">
              <div class="label">Farm</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 9 }" @click="onBgChange({ type: 'stock', data: 9 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_9_s.jpg') + ')'}">
              <div class="label">Food</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 10 }" @click="onBgChange({ type: 'stock', data: 10 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_10_s.jpg') + ')'}">
              <div class="label">Gym</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 11 }" @click="onBgChange({ type: 'stock', data: 11 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_11_s.jpg') + ')'}">
              <div class="label">Hospital</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 12 }" @click="onBgChange({ type: 'stock', data: 12 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_12_s.jpg') + ')'}">
              <div class="label">Lake</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 13 }" @click="onBgChange({ type: 'stock', data: 13 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_13_s.jpg') + ')'}">
              <div class="label">Mountains</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 14 }" @click="onBgChange({ type: 'stock', data: 14 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_14_s.jpg') + ')'}">
              <div class="label">Mountains</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 15 }" @click="onBgChange({ type: 'stock', data: 15 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_15_s.jpg') + ')'}">
              <div class="label">Music</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 16 }" @click="onBgChange({ type: 'stock', data: 16 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_16_s.jpg') + ')'}">
              <div class="label">Office</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 17 }" @click="onBgChange({ type: 'stock', data: 17 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_17_s.jpg') + ')'}">
              <div class="label">Restaurant</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 18 }" @click="onBgChange({ type: 'stock', data: 18 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_18_s.jpg') + ')'}">
              <div class="label">School</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 19 }" @click="onBgChange({ type: 'stock', data: 19 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_19_s.jpg') + ')'}">
              <div class="label">Sea</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 20 }" @click="onBgChange({ type: 'stock', data: 20 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_20_s.jpg') + ')'}">
              <div class="label">Shopping</div>
            </div>
          </div>
          <div class="bg-box">
            <div :class="{ 'image': true, selected: getCurrentBotBg.type == 'stock' && getCurrentBotBg.data == 21 }" @click="onBgChange({ type: 'stock', data: 21 })" :style="{'background-image': 'url(' + require('../../assets/backgrounds/b_21_s.jpg') + ')'}">
              <div class="label">Travel</div>
            </div>
          </div>

        </div>
      </div>

      <div class="person-menu" v-if="paletteBar == 'person'">
        <div class="person-shell">
          
          <div class="person-box">
            <div :class="{'upload-btn-wrapper': true, selected: getCurrentBotPerson.type == 'upload'}" :style="{'background-image': 'url(' + getUploadedPerson + ')'}">
              <input type="file" name="myfile" class="uploadedPerson" @input="uploadPerson" @click="inputPersonClick" title=""/>
              <div class="label">Upload</div>
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image-default': true, selected: getCurrentBotPerson.type == null }" @click="onPersonChange({ type: null })">
              <div class="label">none</div>
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 1 }" @click="onPersonChange({ type: 'stock', data: 1 })">
              <img src="../../assets/persons/p_1_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 2 }" @click="onPersonChange({ type: 'stock', data: 2 })">
              <img src="../../assets/persons/p_2_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 3 }" @click="onPersonChange({ type: 'stock', data: 3 })">
              <img src="../../assets/persons/p_3_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 4 }" @click="onPersonChange({ type: 'stock', data: 4 })">
              <img src="../../assets/persons/p_4_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 5 }" @click="onPersonChange({ type: 'stock', data: 5 })">
              <img src="../../assets/persons/p_5_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 6 }" @click="onPersonChange({ type: 'stock', data: 6 })">
              <img src="../../assets/persons/p_6_s.png">
            </div>
          </div>

          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 7 }" @click="onPersonChange({ type: 'stock', data: 7 })">
              <img src="../../assets/persons/p_7_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 8 }" @click="onPersonChange({ type: 'stock', data: 8 })">
              <img src="../../assets/persons/p_8_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 9 }" @click="onPersonChange({ type: 'stock', data: 9 })">
              <img src="../../assets/persons/p_9_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 10 }" @click="onPersonChange({ type: 'stock', data: 10 })">
              <img src="../../assets/persons/p_10_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 11 }" @click="onPersonChange({ type: 'stock', data: 11 })">
              <img src="../../assets/persons/p_11_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 12 }" @click="onPersonChange({ type: 'stock', data: 12 })">
              <img src="../../assets/persons/p_12_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 13 }" @click="onPersonChange({ type: 'stock', data: 13 })">
              <img src="../../assets/persons/p_13_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 14 }" @click="onPersonChange({ type: 'stock', data: 14 })">
              <img src="../../assets/persons/p_14_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 15 }" @click="onPersonChange({ type: 'stock', data: 15 })">
              <img src="../../assets/persons/p_15_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 16 }" @click="onPersonChange({ type: 'stock', data: 16 })">
              <img src="../../assets/persons/p_16_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 17 }" @click="onPersonChange({ type: 'stock', data: 17 })">
              <img src="../../assets/persons/p_17_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 18 }" @click="onPersonChange({ type: 'stock', data: 18 })">
              <img src="../../assets/persons/p_18_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 19 }" @click="onPersonChange({ type: 'stock', data: 19 })">
              <img src="../../assets/persons/p_19_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 20 }" @click="onPersonChange({ type: 'stock', data: 20 })">
              <img src="../../assets/persons/p_20_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 21 }" @click="onPersonChange({ type: 'stock', data: 21 })">
              <img src="../../assets/persons/p_21_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 22 }" @click="onPersonChange({ type: 'stock', data: 22 })">
              <img src="../../assets/persons/p_22_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 23 }" @click="onPersonChange({ type: 'stock', data: 23 })">
              <img src="../../assets/persons/p_23_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 24 }" @click="onPersonChange({ type: 'stock', data: 24 })">
              <img src="../../assets/persons/p_24_s.png">
            </div>
          </div>
          <div class="person-box">
            <div :class="{ 'image': true, selected: getCurrentBotPerson.type == 'stock' && getCurrentBotPerson.data == 25 }" @click="onPersonChange({ type: 'stock', data: 25 })">
              <img src="../../assets/persons/p_25_s.png">
            </div>
          </div>

        </div>
      </div>
    </div>
    </div>
    
    <chrome-picker v-model="bg_color" class="picker" v-if="picker" @input="onBgChange({ type: 'color', data: bg_color })"/>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import autosize from 'autosize'
import { mapActions, mapGetters } from 'vuex';
import { Chrome } from 'vue-color'
import Compress from 'client-compress'
import loadVoices from '@/lib/ttsVoices'

export default {
  name: 'Bot',
  props: {
    botData: Object
  },
  data() {
    return {
      id: this.botData.id,
      switch: this.botData.audioType,
      playing: false,
      recording: false,
      recordingTime: this.botData.recordingTime,
      timerTimeOut: null,
      text: this.botData.text,
      data: this.botData.audioData,
      paletteBar: this.botData.audioType,
      background: this.botData.background,
      bg_color: { hex: '#3e4046'},
      picker: false,
      upload: null,
      voices: [],
      selectedVoice: this.botData.selectedVoice
    }
  },
  components: {
    'chrome-picker': Chrome,
  },
  methods: {
    ...mapActions('create', ['botSaveText', 'botSaveTime', 'botChangeSwitch', 'botChangeAudioData', 'deleteBot', 'botBackgroundChange', 'botPersonChange', 'saveToBackgroundStore', 'saveToPersonStore', 'botChangeVoice', 'pathBack', 'botChangeBottomBar']),
    ...mapActions('player', ['playerPlay', 'playerStop', 'playerRecordingStart', 'playerRecordingStop']),
    prevent(event) {
      event.preventDefault();
      document.querySelector('.create-answer-textarea').focus();
    },
    onVoiceChange() {
      this.botChangeVoice({ voice: this.selectedVoice, id: this.id});
    },
    botSwitchChange() {
      if(this.switch == 'bot') {
        this.switchChange(null);
        this.paletteBar = null;
      } else {
        this.switchChange('bot');
        this.paletteBar = 'bot';
      }
    },
    microSwitchChange() {
      if(this.switch == 'micro') {
        this.switchChange(null);
        this.paletteBar = null;
      } else {
        this.switchChange('micro');
        this.paletteBar = 'micro';
      }
    },
    switchChange(to) {
      if(this.playing) {
        this.stop();
      }
      if(this.recording) {
        this.stopRecord();
      }
      this.switch = to;
      this.botChangeSwitch({ switchState: this.switch, id: this.id});
    },
    playButton() {
      if(!this.recording) {
        if(this.playing) {
          this.stop();
        } else {
          if(this.playingState) {
            this.playerStop();
            this.play();
          } else {
            this.play();
          }
        }
      } else {
        console.log(`Error: Recording`);
        alert.showError('Recording');
      }
    },
    play() {
      if(this.switch == 'bot' && this.text.trim() != '') {
        this.playing = true;
        this.playerPlay({ type: 'bot', payload: { text: this.text, voice: this.selectedVoice } }).then(() => {
          this.playing = false;
        }).catch(err => {
          this.playing = false;
          console.log(`Error: ${err}`);
          alert.showError(err);
        });
      } else if(this.switch == 'micro'){
        this.playing = true;
        this.playerPlay({ type: 'micro', payload: this.data }).then(() => {
          this.playing = false;
        }).catch(err => {
          this.playing = false;
          console.log(`Error: ${err}`);
          alert.showError(err);
        });
      } else if(this.text.trim() == '') {
        console.log(`Error: No text to read`);
        alert.showError('No text to read');
      }
    },
    stop() {
      this.playerStop();
      this.playing = false;
    },
    recordButton() {
      if(!this.recording) {
        this.record();
      } else if(this.recording){
        this.stopRecord();
      }
    },
    record() {
      this.playerRecordingStart().then(() => {
        this.recordingTime = 0;
        this.timer();
        this.recording = true;
      }).catch(err => {
        console.log(`Error: ${err}`);
      })
    },
    stopRecord() {
      this.recording = false;
      clearTimeout(this.timerTimeOut);
      this.botSaveTime({time: this.recordingTime, id: this.id});
      this.playerRecordingStop().then(data => {
        this.data = data.data;
        this.botChangeAudioData({ audioData: this.data, id: this.id});
      }).catch(err => {
        console.log(`Error: ${err}`);
        alert.showError(err);
      })
    },
    timer() {
      this.recordingTime += 1;
      if(this.recordingTime == 60) {
        this.stopRecord();
      } else {
        this.timerTimeOut = setTimeout(this.timer, 1000);
      }
    },
    saveText() {
      this.botSaveText({text: this.text, id: this.id});
    },
    onDelete() {
      this.deleteBot(this.botData.id);
    },
    onBgChange(object) {
      this.botBackgroundChange({object, id: this.id});
      if(object.type != 'color') {
        this.picker = false;
      }
    },
    onPersonChange(object) {
      this.botPersonChange({object, id: this.id});
    },
    pickerSwitch() {
      this.onBgChange({ type: 'color', data: this.bg_color })
      this.picker = true;
    },
    backgroundPaletteSwitch() {
      this.picker = false;
      if(this.paletteBar == 'bg') {
        if(this.switch == 'micro') {
          this.paletteBar = 'micro';
        } else if(this.switch == 'bot') {
          this.paletteBar = 'bot';
        } else {
          this.paletteBar = null;
        }
      } else {
        this.paletteBar = 'bg';
      }
    },
    personPaletteSwitch() {
      if(this.paletteBar == 'person') {
        if(this.switch == 'micro') {
          this.paletteBar = 'micro';
        } else if(this.switch == 'bot') {
          this.paletteBar = 'bot';
        } else {
          this.paletteBar = null;
        }
        this.picker = false;
      } else {
        this.paletteBar = 'person';
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    uploadBackground() {
      const file = document.querySelector('.uploadedBackground').files[0];
      if(file) {
        if(file.size > 5242880) {
          console.log('image too large')
          alert.showError('image too large');
        } else if(file.type != 'image/jpeg' && file.type != 'image/png') {
          console.log('bad file type, use JPG or PNG')
          alert.showError('bad file type, use JPG or PNG');
        } else {
          let existing = this.getBackgroundStore.find(object => {
            return object.name == file.name;
          })
          if(!existing) {
            const options = {
              quality: 0.5,
            }
            const compress = new Compress(options)

            let files_array = [...document.querySelector('.uploadedBackground').files]
            compress.compress(files_array).then(conversions => {
              const { photo } = conversions[0]
              let blob = photo.data;
              this.fileToBase64(blob).then(result => {
                this.onBgChange({ type: 'upload', data: file.name });
                this.saveToBackgroundStore({ name: file.name, data: result });
              }).catch(err => {
                console.log(err);
                alert.showError(err);
              })
            })

          } else {
            this.onBgChange({ type: 'upload', data: file.name });
          }
        }
      }
    },
    inputBackgroundClick() {
      
    },
    uploadPerson() {
      const file = document.querySelector('.uploadedPerson').files[0];
      if(file) {
        if(file.size > 1048576) {
          console.log('image too large')
          alert.showError('image too large');
        } else if(file.type != 'image/jpeg' && file.type != 'image/png') {
          console.log('bad file type, use JPG or PNG')
          alert.showError('bad file type, use JPG or PNG');
        } else {
          let existing = this.getPersonStore.find(object => {
            return object.name == file.name;
          })
          if(!existing) {

            this.fileToBase64(file).then(result => {
              this.onPersonChange({ type: 'upload', data: file.name });
              this.saveToPersonStore({ name: file.name, data: result });
            }).catch(err => {
              console.log(err);
              alert.showError(err);
            })

          } else {
            this.onPersonChange({ type: 'upload', data: file.name });
          }
        }
      }
    },
    inputPersonClick() {

    },
    goBack() {
      this.playerStop();
      this.pathBack();
    },
    onChangeBottomBar() {
      this.botChangeBottomBar();
    }
  },
  mounted() {
    this.$refs.questionInput.focus();
    autosize(document.querySelector('textarea'));
    loadVoices().then(voices => {
      this.voices = voices;
    })
  },
  computed: {
    ...mapGetters('player', ['playingState']),
    ...mapGetters('create', ['getFirstBotId', 'getCurrentBotBg', 'getCurrentBotPerson', 'getUploadedBackground', 'getUploadedPerson', 'getCurrentBotAudioType', 'getBackgroundStore', 'getPersonStore', 'path', 'getBottomBarState']),
    time() {
      if(this.recordingTime < 10) {
        return '00:0' + this.recordingTime;
      } else {
        return '00:' + this.recordingTime;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 30rem;
  min-height: 7rem;
  height: auto;
  flex-direction: column;
  position: relative;
  background-color: rgb(37, 38, 41);
  border-radius: 0.8rem;
  filter:drop-shadow(8px 8px 20px rgba(0, 0, 0, 0.349));
  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }

  .text {
    width: 100%;
    height: auto;
    background-color: #11b6a5;
    border-radius: 0.5rem;
    position: relative;
    padding-bottom: 1rem;
    border-radius: 0.5rem;

    .switch-bottom-box {
      position: absolute;
      left: 0.5rem;
      bottom: 0.5rem;
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 0.3rem;
      background-color: rgb(37, 38, 41);
      color: white;
      cursor: pointer;
      font-size: 1.1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .play-box {
      width: auto;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 0.5rem;
      bottom: 0.5rem;
      @media (max-width: 1000px) {
        height: 3rem;
      }

      .playing {
        background-color: #292f36 !important;
        color: white !important;
      }

      .play {
        width: 2.2rem;
        height: 2.2rem;
        border-radius: 50%;
        background-color: white;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: 0.3s;
        font-size: 0.9rem;
        @media (max-width: 1000px) {
          width: 2rem;
          height: 2rem;
          font-size: 1rem;
        }
      }
    }

    textarea {
      color: white;
      width: 100%;
      height: 100%;
      min-height: 8rem;
      background: none;
      border: none;
      text-align: justify;
      font-size: 1.2rem;
      padding: 1rem;
      resize: none;
      outline: none;
      overflow: hidden;
      display: block;
      box-sizing: padding-box;
      @media (max-width: 1000px) {
        font-size: 1rem;
      }
      &::placeholder {
        color: white;
      }
    }
  }

  .option-bar {
    width: 100%;
    height: 3rem;
    background-color: rgb(37, 38, 41);
    display: flex;
    flex-direction: row;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    @media (max-width: 1000px) {
      height: 3rem;
    }
    user-select: none;

    .switch {
      width: 7rem;
      height: 3rem;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      @media (max-width: 1000px) {
        height: 3rem;
      }

      .bot {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 1rem;
        }

        &:hover {
          cursor: pointer;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .micro {
        width: 2rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border-radius: 0.5rem;
        color: rgb(37, 38, 41);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 1rem;
        }

        &:hover {
          cursor: pointer;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .active {
        background-color: rgb(131, 83, 194);
        color: white;
      }
    }

    .background-trigger-box {
      width: 3rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 1000px) {
        height: 3rem;
      }

      .background-button {
        width: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;
        background-color: rgb(79, 87, 87);

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .active {
        background-color: darkcyan;
      }
    }

    .person-trigger-box {
      width: 3rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 1000px) {
        height: 3rem;
      }

      .person-button {
        width: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;
        background-color: rgb(79, 87, 87);

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .active {
        background-color: darkcyan;
      }
    }

    .delete-box {
      width: 4rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      @media (max-width: 1000px) {
        height: 3rem;
      }

      .delete-button {
        width: 2rem;
        height: 2rem;
        background-color: rgb(196, 79, 68);
        border-radius: 0.5rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;

        @media (max-width: 1000px) {
          width: 1.9rem;
          height: 1.9rem;
          font-size: 0.95rem;
        }

        &:active {
          transform: scale(0.9);
        }
      }
    }

  }

  .palette-bar {
    width: 100%;
    min-height: 4rem;
    border-top: 2px dashed rgb(116, 111, 111);
    background-color: rgb(37, 38, 41);
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    user-select: none;

    .menu {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;

      .background {
        width: 4rem;
        height: 100%;
        margin-left: 1rem;
        border: none;
        outline: none;
        border-radius: 0.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background 0.3s;
        color: white;
        font-size: 2rem;

        &:hover {
          background-color: rgb(64, 66, 70);
        }
      }

      .person {
        width: 4rem;
        height: 100%;
        margin-left: 0.5rem;
        border: none;
        outline: none;
        border-radius: 0.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background 0.3s;
        color: white;
        font-size: 1.8rem;

        &:hover {
          background-color: rgb(64, 66, 70);
        }
      }
    }

    .tts-menu {
      flex: 1;
      display: flex;
      align-items: center;

      .label {
        margin-left: 1rem;
        font-size: 1.2rem;
        color: white;
      }

      select {
        margin-left: 1rem;
        width: 15rem;
        height: 2rem;
        border-radius: 0.3rem;
        outline: none;
      }
    }

    .record-menu {
      flex: 1;
      display: flex;
      align-items: center;

      .record {
        width: 2.2rem;
        height: 2.2rem;
        font-size: 1.2rem;
        border-radius: 50%;
        background-color: rgb(224, 224, 224);
        color: rgb(224, 116, 106);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: 1rem;
        @media (max-width: 1000px) {
          width: 1.7rem;
          height: 1.7rem;
          font-size: 0.95rem;
        }
      }

      .recording {
        animation: flashing 2s infinite;
        background-color: rgb(224, 116, 106);
        color: rgb(224, 224, 224);
      }

      @keyframes flashing {
        20% {
          background-color: rgb(224, 116, 106);
        }
        50% {
          background-color: rgb(196, 33, 19);
        }
        80% {
          background-color: rgb(224, 116, 106);
        }
      }

      .timer {
        width: 7rem;
        height: 2.2rem;
        margin-left: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
      }
    }

    .background-menu {
      width: 100%;
      height: 11rem;
      display: flex;
      align-items: center;
      overflow: auto;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

      &::-webkit-scrollbar {
        width: 0.5rem;
      }
      &::-webkit-scrollbar-track {
        background-color: rgb(49, 51, 54);
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgb(102, 106, 117);
        border-radius: 1rem;
      }

      .background-shell {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        flex-wrap: wrap;

        .bg-box {
          width: 8rem;
          min-height: 5rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .image-default {
            width: 7rem;
            height: 4rem;
            position: relative;
            border-radius: 0.4rem;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            overflow: hidden;
            border: 2px solid rgba(255, 255, 255, 0.61);

            .icon {
              color: white;
              font-size: 1.5rem;
              position: absolute;
              top: 0.6rem;
              left: 0.6rem;
            }

            .label {
              color: white;
              font-size: 1rem;
              font-weight: bold;
              background-color: rgb(49, 51, 54);
              position: absolute;
              bottom: 0.3rem;
              right: 0.3rem;
              padding-left: 0.2rem;
              padding-right: 0.2rem;
              border-radius: 0.2rem;
            }
          }

          .selected {
            border: 2px solid yellow;
          }

          .image {
            width: 7rem;
            height: 4rem;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            border-radius: 0.4rem;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            overflow: hidden;
            border: 2px solid rgba(255, 255, 255, 0.61);

            .label {
              color: white;
              font-size: 1rem;
              font-weight: bold;
              background-color: rgb(49, 51, 54);
              padding-left: 0.2rem;
              padding-right: 0.2rem;
              border-radius: 0.2rem;
              margin-right: 0.3rem;
              margin-bottom: 0.3rem;
            }
          }

          .selected {
            border: 2px solid yellow;
          }

          .upload-btn-wrapper {
            width: 7rem;
            height: 4rem;
            position: relative;
            border-radius: 0.4rem;
            overflow: hidden;
            display: inline-block;
            border: 2px solid rgba(255, 255, 255, 0.61);
            background-repeat: no-repeat;
            background-size: cover;

            .label {
              color: white;
              font-size: 1rem;
              font-weight: bold;
              background-color: rgb(49, 51, 54);
              position: absolute;
              bottom: 0.3rem;
              right: 0.3rem;
              padding-left: 0.2rem;
              padding-right: 0.2rem;
              border-radius: 0.2rem;
              z-index: 1;
            }

            input {
              position: absolute;
              left: 0;
              top: 0;
              width: 7rem;
              height: 3rem;
              opacity: 0;
              z-index: 2;
              &:hover {
                cursor: pointer;
              }
            }
          }

          .selected {
            border: 2px solid yellow;
          }
        }
      }
    }

    .person-menu {
      width: 100%;
      height: 11rem;
      display: flex;
      align-items: center;
      overflow: auto;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

      &::-webkit-scrollbar {
        width: 0.5rem;
      }
      &::-webkit-scrollbar-track {
        background-color: rgb(49, 51, 54);
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgb(102, 106, 117);
        border-radius: 1rem;
      }

      .person-shell {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        flex-wrap: wrap;

        .person-box {
          width: 8rem;
          min-height: 5rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .image-default {
            width: 7rem;
            height: 4rem;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            border-radius: 0.4rem;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            overflow: hidden;
            border: 2px solid rgba(255, 255, 255, 0.61);

            .label {
              color: white;
              font-size: 1rem;
              font-weight: bold;
              background-color: rgb(49, 51, 54);
              padding-left: 0.2rem;
              padding-right: 0.2rem;
              border-radius: 0.2rem;
              margin-right: 0.3rem;
              margin-bottom: 0.3rem;
            }
          }

          .selected {
            border: 2px solid yellow;
          }

          .image {
            width: 7rem;
            height: 4rem;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            border-radius: 0.4rem;
            cursor: pointer;
            overflow: hidden;
            background-color: white;
            border: 2px solid rgba(255, 255, 255, 0.61);

            img {
              height: 95%;
            }

            .label {
              color: white;
              font-size: 1rem;
              font-weight: bold;
              background-color: rgb(49, 51, 54);
              padding-left: 0.2rem;
              padding-right: 0.2rem;
              border-radius: 0.2rem;
              margin-right: 0.3rem;
              margin-bottom: 0.3rem;
            }
          }

          .selected {
            border: 2px solid yellow;
          }

          .upload-btn-wrapper {
            width: 7rem;
            height: 4rem;
            position: relative;
            border-radius: 0.4rem;
            overflow: hidden;
            display: inline-block;
            border: 2px solid rgba(255, 255, 255, 0.61);
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;

            .label {
              color: white;
              font-size: 0.9rem;
              font-weight: bold;
              background-color: rgb(49, 51, 54);
              position: absolute;
              bottom: 0.3rem;
              right: 0.3rem;
              padding-left: 0.2rem;
              padding-right: 0.2rem;
              border-radius: 0.2rem;
              z-index: 1;
            }

            input {
              position: absolute;
              left: 0;
              top: 0;
              width: 7rem;
              height: 3rem;
              opacity: 0;
              z-index: 2;
              &:hover {
                cursor: pointer;
              }
            }
          }

          .selected {
            border: 2px solid yellow;
          }
        }
      }
    }
  }

  .picker {
    position: absolute;
    width: 10rem;
    left: 2.5rem;
    bottom: -12.5rem;
  }
}
</style>